const namespaced = true
import _ from 'lodash';
import api from '../../../api/catalogs/failures.js';

const state = {
    failures_catalogs: '',
    loading_failure: false,
}
const mutations = {
    SET_FAILURE(state, data) {
        state.failures_catalogs = data;
    },
    SET_LOADING_FAILURE(state, data) {
        state.loading_failure = data;
    },
    ADD_FAILURE(state, value) {
        state.failures_catalogs.push(value);
    },
    UPDATE_FAILURE(state, value) {
        const newArr = _.clone(state.failures_catalogs);
        const index = _.findIndex(state.failures_catalogs, function (o) { return o.id == value.id });
        if (index !== -1) {
            newArr[index] = value;
        }
        state.failures_catalogs = newArr
    },
    DELETE_FAILURE(state, value) {
        // state.failures_catalogs.splice(_.findIndex(state.failures_catalogs, function (o) { return o.id == value }), 1); //Ese codigo si elimina el elemento del arreglo 
        state.failures_catalogs.find(item => item.id === value.id).active = value.active;
    },
}
const actions = {
    getFailures(context, data) {
        context.commit('SET_LOADING_FAILURE', true);
        return new Promise((resolve) => {
            api.getFailures(data).then(function (res) {
                context.commit('SET_FAILURE', res.data.data);
                resolve(res.data);
                context.commit('SET_LOADING_FAILURE', false);
                context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': res.data.message }, { root: true });
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOADING_FAILURE', false);
            })
        })
    },
    addFailure(context, data) {
        context.commit('SET_LOADING_FAILURE', true);
        return new Promise((resolve) => {
            api.addFailure(data).then(function (res) {
                context.commit('ADD_FAILURE', res.data.data);
                resolve(res);
                context.commit('SET_LOADING_FAILURE', false);
                context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': res.data.message }, { root: true });
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOADING_FAILURE', false);
            })
        })
    },
    updateFailure(context, data) {
        context.commit('SET_LOADING_FAILURE', true);
        return new Promise((resolve) => {
            api.updateFailure(data.id, data.data).then(function (res) {
                context.commit('UPDATE_FAILURE', res.data.data);
                resolve(res);
                context.commit('SET_LOADING_FAILURE', false);
                context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': res.data.message }, { root: true });
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOADING_FAILURE', false);
            })
        })
    },
    deleteFailure(context, id) {
        context.commit('SET_LOADING_FAILURE', true);
        return new Promise((resolve) => {
            api.deleteFailure(id).then(function (res) {
                context.commit('DELETE_FAILURE', res.data.data);
                context.dispatch("notifications/add", { color: "success", visibility: true, timeout: 5000, text: res.data.message, }, { root: true });
                resolve(res.data);
                context.commit('SET_LOADING_FAILURE', false);
            }).catch(function (error) {
                console.log(error)
                context.commit('SET_LOADING_FAILURE', false);
            })
        })
    },
}
const getters = {
    getFailuresCatalogs(state) {
        return _.orderBy(state.failures_catalogs, ['id'], ['desc'])
    },
}

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
}